import fail   from './fail'
import reload from './reload'

export default
{
    fail,
    reload
};
